import { dew as _reDew } from "./internal/re";
import { dew as _constantsDew } from "./internal/constants";
import { dew as _semverDew } from "./classes/semver";
import { dew as _identifiersDew } from "./internal/identifiers";
import { dew as _parseDew } from "./functions/parse";
import { dew as _validDew } from "./functions/valid";
import { dew as _cleanDew } from "./functions/clean";
import { dew as _incDew } from "./functions/inc";
import { dew as _diffDew } from "./functions/diff";
import { dew as _majorDew } from "./functions/major";
import { dew as _minorDew } from "./functions/minor";
import { dew as _patchDew } from "./functions/patch";
import { dew as _prereleaseDew } from "./functions/prerelease";
import { dew as _compareDew } from "./functions/compare";
import { dew as _rcompareDew } from "./functions/rcompare";
import { dew as _compareLooseDew } from "./functions/compare-loose";
import { dew as _compareBuildDew } from "./functions/compare-build";
import { dew as _sortDew } from "./functions/sort";
import { dew as _rsortDew } from "./functions/rsort";
import { dew as _gtDew } from "./functions/gt";
import { dew as _ltDew } from "./functions/lt";
import { dew as _eqDew } from "./functions/eq";
import { dew as _neqDew } from "./functions/neq";
import { dew as _gteDew } from "./functions/gte";
import { dew as _lteDew } from "./functions/lte";
import { dew as _cmpDew } from "./functions/cmp";
import { dew as _coerceDew } from "./functions/coerce";
import { dew as _comparatorDew } from "./classes/comparator";
import { dew as _rangeDew } from "./classes/range";
import { dew as _satisfiesDew } from "./functions/satisfies";
import { dew as _toComparatorsDew } from "./ranges/to-comparators";
import { dew as _maxSatisfyingDew } from "./ranges/max-satisfying";
import { dew as _minSatisfyingDew } from "./ranges/min-satisfying";
import { dew as _minVersionDew } from "./ranges/min-version";
import { dew as _valid2Dew } from "./ranges/valid";
import { dew as _outsideDew } from "./ranges/outside";
import { dew as _gtrDew } from "./ranges/gtr";
import { dew as _ltrDew } from "./ranges/ltr";
import { dew as _intersectsDew } from "./ranges/intersects";
import { dew as _simplifyDew } from "./ranges/simplify";
import { dew as _subsetDew } from "./ranges/subset";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  // just pre-load all the stuff that index.js lazily exports
  const internalRe = _reDew();
  const constants = _constantsDew();
  const SemVer = _semverDew();
  const identifiers = _identifiersDew();
  const parse = _parseDew();
  const valid = _validDew();
  const clean = _cleanDew();
  const inc = _incDew();
  const diff = _diffDew();
  const major = _majorDew();
  const minor = _minorDew();
  const patch = _patchDew();
  const prerelease = _prereleaseDew();
  const compare = _compareDew();
  const rcompare = _rcompareDew();
  const compareLoose = _compareLooseDew();
  const compareBuild = _compareBuildDew();
  const sort = _sortDew();
  const rsort = _rsortDew();
  const gt = _gtDew();
  const lt = _ltDew();
  const eq = _eqDew();
  const neq = _neqDew();
  const gte = _gteDew();
  const lte = _lteDew();
  const cmp = _cmpDew();
  const coerce = _coerceDew();
  const Comparator = _comparatorDew();
  const Range = _rangeDew();
  const satisfies = _satisfiesDew();
  const toComparators = _toComparatorsDew();
  const maxSatisfying = _maxSatisfyingDew();
  const minSatisfying = _minSatisfyingDew();
  const minVersion = _minVersionDew();
  const validRange = _valid2Dew();
  const outside = _outsideDew();
  const gtr = _gtrDew();
  const ltr = _ltrDew();
  const intersects = _intersectsDew();
  const simplifyRange = _simplifyDew();
  const subset = _subsetDew();
  exports = {
    parse,
    valid,
    clean,
    inc,
    diff,
    major,
    minor,
    patch,
    prerelease,
    compare,
    rcompare,
    compareLoose,
    compareBuild,
    sort,
    rsort,
    gt,
    lt,
    eq,
    neq,
    gte,
    lte,
    cmp,
    coerce,
    Comparator,
    Range,
    satisfies,
    toComparators,
    maxSatisfying,
    minSatisfying,
    minVersion,
    validRange,
    outside,
    gtr,
    ltr,
    intersects,
    simplifyRange,
    subset,
    SemVer,
    re: internalRe.re,
    src: internalRe.src,
    tokens: internalRe.t,
    SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: constants.RELEASE_TYPES,
    compareIdentifiers: identifiers.compareIdentifiers,
    rcompareIdentifiers: identifiers.rcompareIdentifiers
  };
  return exports;
}